import React from "react";
import { IBowser } from "bowser";
import { imageHost } from "@wss/image";
import PrimaryImage from "~/common/MediaViewerV2/SharedComponents/ImageViewer/PrimaryImage";
import { Image } from "~/common/MediaViewerV2/model";
interface ImageMediaRendererProps {
  index: number;
  image: Image;
  title: string;
  openZoom: () => void;
  overlayOpen: boolean;
  isMobileScreenSize: boolean;
  placeholderImageUrl: string;
  bowser?: Readonly<IBowser>;
}
const ImageMediaRenderer = ({
  index,
  image,
  title,
  openZoom,
  overlayOpen,
  isMobileScreenSize,
  placeholderImageUrl,
  bowser
}: ImageMediaRendererProps) => {
  return <div className="h-full mx-auto w-full" data-sentry-component="ImageMediaRenderer" data-sentry-source-file="ImageMediaRenderer.tsx">
      <PrimaryImage src={`${imageHost}${image.large}`} medium={image} alt={image.alternateText || title} openZoom={openZoom} overlayOpen={overlayOpen} isMobileScreenSize={isMobileScreenSize} imageNote={image.imageNote} isIE={bowser?.msie} index={index} placeholderImageUrl={placeholderImageUrl} data-sentry-element="PrimaryImage" data-sentry-source-file="ImageMediaRenderer.tsx" />
    </div>;
};
export default ImageMediaRenderer;